import { UIHeading5 } from '@cian/ui-kit';
import * as React from 'react';

import { CroppedPhone } from './CroppedPhone';
import * as styles from './styles.css';

export interface ICallContact {
  displayName?: string | null;
  avatar?: string | null;
  description?: string | null;
}

interface IContactsPopupTooltipProps {
  isPhoneVisible: boolean;
  contact: ICallContact;
  phone: string;
  onPhoneClick(): void;
}

export const ContactsPopup: React.FC<IContactsPopupTooltipProps> = ({
  contact,
  phone,
  isPhoneVisible,
  onPhoneClick,
}) => {
  return (
    <div className={styles['container']} data-testid="ContactsPopup">
      <div className={styles['contact']}>
        <div className={styles['contact-logo']}>
          {contact.avatar && <img src={contact.avatar} className={styles['contact-logo_img']} />}
        </div>
        <div className={styles['contact-content']}>
          <UIHeading5 display="inline-block">{contact.displayName}</UIHeading5>
          {contact.description && <p className={styles['contact-description']}>{contact.description}</p>}
          <CroppedPhone phone={phone} isCropped={!isPhoneVisible} onClick={onPhoneClick} />
        </div>
      </div>
    </div>
  );
};
